export {
    default as Toggle,
    IToggleProps,
} from './toggle';
